import { useState } from "react";
import logo from "../assets/images/logoFWA.png";

export default function Header({ scrollToSection }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const menuItems = [
    { label: "Services", section: "services" },
    { label: "Portfolio", section: "portfolio" },
    // { label: "Tarifs", section: "tarifs" },
    { label: "FAQ", section: "faq" },
    { label: "Contact", section: "contact", isPrimary: true },
  ];

  return (
    <header className="header-nav bg-white shadow-md fixed w-full z-50">
      <div className="container flex items-center justify-between h-full p-2">
        <a href="/" className="logo min-w-[50px]">
          <img src={logo} alt="Fold Web Agency" style={{ margin: "5px", width: 150 }} />
        </a>

        {/* Desktop Menu */}
        <nav className="hidden md:flex gap-2 items-center">
          {menuItems.map((item) => (
            <button
              key={item.section}
              onClick={() => scrollToSection(item.section)}
              className={`text-sm ${item.isPrimary ? "btn-primary" : "btn-secondary"}`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Mobile Burger */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMobileMenu} className="focus:outline-none">
            {/* Trois traits */}
            <div className="space-y-1">
              <span className="block w-6 h-0.5 bg-gray-800"></span>
              <span className="block w-6 h-0.5 bg-gray-800"></span>
              <span className="block w-6 h-0.5 bg-gray-800"></span>
            </div>
          </button>
        </div>
      </div>

       {/* Mobile Menu Dropdown */}
  {isMobileMenuOpen && (
    <div className="absolute top-full right-0 w-40 bg-white shadow-md rounded-b-lg overflow-hidden z-10">
      {menuItems.map((item, index) => (
        <button
          key={item.section}
          onClick={() => {
            scrollToSection(item.section);
            setIsMobileMenuOpen(false); // ferme le menu après clic
          }}
          className={`w-full text-left px-4 py-3 ${
            item.isPrimary
              ? "bg-black text-white hover:bg-gray-800"
              : "bg-white text-gray-800 hover:bg-gray-100"
          } ${index !== menuItems.length - 1 ? "border-b border-gray-200" : ""}`}
        >
          {item.label}
        </button>
      ))}
    </div>
  )}

    </header>
  );
}
